import { ValidationErrors } from '@angular/forms';
import type { ValidationError } from '@angular/forms/signals';

/** Signal Forms errors are `ValidationError` objects keyed by `kind`, carrying an optional message. */
function isSignalFormError(value: unknown): value is ValidationError {
  return typeof value === 'object' && value !== null && typeof (value as ValidationError).kind === 'string';
}

/**
 * @param errors Angular form errors object, i.e. FormControl.errors
 * @returns An array containing an error text for each error. */
export function errorsToText(errors: ValidationErrors): string[] {
  if (!errors) return [];

  return Object.entries(errors).map(([key, value]) => {
    if (typeof value === 'string' || typeof value === 'undefined') return value;
    if (isSignalFormError(value) && value.message) return value.message;

    switch (key) {
      case 'required':
        return 'A value is required';
      case 'maxlength':
        return `Maximum length: ${value['requiredLength']}\nActual length: ${value['actualLength']}`;

      default:
        return `${key}: ${JSON.stringify(value)}`;
    }
  });
}
